.caption {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: var(--tl-dim);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding-bottom: 14px;
    border-bottom: 1px solid var(--tl-border);
    width: 100%;
    margin: 0;
    line-height: 1.4;
}
